import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/NavBar';
import Home from './pages/Home';
import Support from './pages/Support';

import ShopManagement from './pages/ShopManagement';
import PropertyManagement from './pages/ShopManagement';

import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solutions/shop_management" element={<ShopManagement />} />
        <Route
          path="/solutions/property_management"
          element={<PropertyManagement />}
        />
        <Route path="/Support" element={<Support />} />

        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
